import ambianceSound from '../../assets/sounds/ambianceSound.wav';
import thunderSound  from '../../assets/sounds/thunderSound.wav';
import swapSound     from '../../assets/sounds/swapSound.wav';
import animalSound   from '../../assets/sounds/animalSound.wav';
import obstacleSound from '../../assets/sounds/obstacleSound.mp3';

export const ambianceAudio = {
    key: 'ambianceSound',
    source: ambianceSound,
    data: {
        mute: false,
        volume: 1,
        rate: 1,
        detune: 0,
        seek: 0,
        loop: true,
        delay: 0
    }
};
export const thunderAudio = {
    key: 'thunderSound',
    source: thunderSound,
    data: {
        mute: false,
        volume: 1,
        rate: 1,
        detune: 0,
        seek: 0,
        loop: false,
        delay: 0
    }
};
export const animalAudio = {
    key: 'animalSound',
    source: animalSound,
    data: {
        mute: false,
        volume: 1,
        rate: 1,
        detune: 0,
        seek: 0,
        loop: false,
        delay: 0
    }
};
export const swapAudio = {
    key: 'swapSound',
    source: swapSound,
    data: {
        mute: false,
        volume: 1,
        rate: 1,
        detune: 0,
        seek: 0,
        loop: false,
        delay: 0
    }
};
export const obstacleAudio = {
    key: 'obstacleSound',
    source: obstacleSound,
    data: {
        mute: false,
        volume: 1,
        rate: 1,
        detune: 0,
        seek: 0,
        loop: false,
        delay: 0
    }
};
